import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  ViewEncapsulation,
  OnDestroy,
  ChangeDetectionStrategy
} from '@angular/core';
import { FocoService } from 'src/app/api/services/foco.service';
import { FocoItem, FocoResponse } from 'src/app/api/models/foco';
import { Product } from 'src/app/api/models/product';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Settings, defaultAnf } from 'src/app/auth/models/settings';
import { AuthService } from 'src/app/auth/services/auth.service';
import { FormControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { firstValueFrom, Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChartConfiguration } from 'chart.js';
import { FocoDialogComponent } from '../foco-dialog/foco-dialog.component';
import { getDaysInMonth, endOfMonth } from 'date-fns';
import { FocoPdfService } from '../../services/foco-pdf.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { saveAs } from 'src/app/shared/utils/file-utils';
import * as ExcelJS from 'exceljs';
import { FocoFilterModalComponent } from '../foco-filter-modal/foco-filter-modal.component';
import { PdfViewerDialogComponent } from '../pdf-viewer-dialog/pdf-viewer-dialog.component';
import { setYear, setMonth, getYear, getMonth } from 'date-fns';

@Component({
    selector: 'app-product-focus',
    templateUrl: './product-focus.component.html',
    styleUrls: ['./product-focus.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [DatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductFocusComponent implements OnInit, OnDestroy {
  private userSettingsSubscription!: Subscription;
  private selectedMonthSubscription!: Subscription;
  private routerEventsSubscription!: Subscription;
  private focoUpdatedSubscription!: Subscription;

  focoItem: FocoItem[] = [];
  dataSource = new MatTableDataSource(
    this.focoItem.filter((item) => item.status === true)
  );

  modalFocoItem: FocoItem[] = [];

  tipos: string[] = ['Stock', 'Margem', 'Validades'];
  currentTipo: string = '';
  filteredDataSource = new MatTableDataSource<FocoItem>();

  @ViewChild(MatSort, { static: false }) set content(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  selectedMonth = new FormControl<Date>(new Date(), { nonNullable: true });
  selectedDate = this.selectedMonth.value;
  dateToUse =
    this.selectedDate < new Date()
      ? endOfMonth(this.selectedDate)
      : this.selectedDate;
  newFocoItem: FocoItem[] = [];
  selectedAnf?: string;
  codigosAnf?: string[];
  role?: string;
  accessLevel?: number;
  isLoading = true;
  totalProgress?: number;
  totalvendas?: number;
  totalFocoInt?: number;
  numProducts100Progress?: number;
  productNames: string[] = [];
  progressValues: number[] = [];
  expectedSalesToDateValues?: number[] = [];
  paceValues?: number[] = [];
  chartData: any[] = [];
  chartDataAbsolute: any[] = [];
  vendasValues?: number[];
  focoIntValues?: number[];
  products: Product[] = [];
  total: number = 0;
  selectedProduct = null;
  dadosAtualizadosA: Date | string | null = null;
  showTable: boolean = false;
  expectedSalesPerDay: number = 0;
  expectedSalesToDate: number = 0;

  // Colunas condicionais para a tabela, dependendo do mês selecionado
  baseColumns = ['cod_produto', 'nome', 'info', 'tipo', 'focoInt'];
  pastMonthColumn = ['vendas', 'emfalta', 'progress'];
  currentMonthColumn = ['vendas', 'stock', 'emfalta', 'progress', 'edit', 'delete'];
  nextMonthColumn = ['stock', 'edit'];
  lastColumns = ['atualizado'];
  displayedColumns = [
    ...this.baseColumns,
    ...this.pastMonthColumn,
    ...this.nextMonthColumn,
    ...this.lastColumns,
  ];
  //
  //this.isPastMonth
  updateTableColumns(): void {
    if (this.isPastMonth) {
      this.displayedColumns = [
        ...this.baseColumns,
        ...this.pastMonthColumn,
        //...this.lastColumns,
      ];
    } else if (this.isCurrentMonth) {
      this.displayedColumns = [
        ...this.baseColumns,
        ...this.currentMonthColumn,
        //...this.lastColumns,
      ];
    } else {
      this.displayedColumns = [
        ...this.baseColumns,
        ...this.nextMonthColumn,
        //...this.lastColumns,
      ];
    }
    this.cdr.detectChanges();
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private changeDetector: ChangeDetectorRef,
    private focoService: FocoService,
    private dialog: MatDialog,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router,
    private datePipe: DatePipe,
    private focoPdfService: FocoPdfService
  ) {
    this.vendasValues = [];
    this.focoIntValues = [];
    this.productNames = [];
    this.progressValues = [];
  }

  ngOnInit(): void {
    let now = new Date();
    this.selectedMonth.setValue(now);
    this.updateTableColumns();

    this.authService.userSettings$.subscribe((settings: Settings | null) => {
      if (settings) {
        // Split the codigosAnf string into an array of strings
        if (settings.codigosAnf) {
          this.codigosAnf = settings.codigosAnf.split(';');
          this.selectedAnf = defaultAnf(this.codigosAnf, settings.codigoAnfPrincipal)!;
        }
        if (settings.role) {
          this.role = settings.role;
        }
        if (settings.accessLevel) {
          this.accessLevel = settings.accessLevel;
        }
      }
      /*       console.log(this.selectedMonth.value.getMonth() + 1);
      console.log('Role: ' + this.role);
      console.log('Access Level: ' + this.accessLevel); */
    });

    this.selectedMonth.valueChanges.subscribe((selectedDate: Date) => {
      // Update dateToUse whenever the user changes the selected date
      this.dateToUse =
        selectedDate < new Date() ? endOfMonth(selectedDate) : selectedDate;

      // Call getFoco to refresh the focoItem data
      this.getFoco();
      // Update table columns based on the selected month
      this.updateTableColumns();
    });
    this.focoService.focoUpdated.subscribe(() => {
      this.calculateProgressValues();
      this.calculateStats();
    });

    this.getFoco();

    /*     this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.getFoco();
      }
    }); */
    this.userSettingsSubscription =
      this.authService.userSettings$.subscribe(/* ... */);
    this.selectedMonthSubscription =
      this.selectedMonth.valueChanges.subscribe(/* ... */);
    this.focoUpdatedSubscription =
      this.focoService.focoUpdated.subscribe(/* ... */);
  }

  ngOnDestroy() {
    if (this.userSettingsSubscription) {
      this.userSettingsSubscription.unsubscribe();
    }
    if (this.selectedMonthSubscription) {
      this.selectedMonthSubscription.unsubscribe();
    }
    if (this.focoUpdatedSubscription) {
      this.focoUpdatedSubscription.unsubscribe();
    }
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }
  }

  openTipoModal(tipo: string): void {
    this.focoService
      .getFoco(this.selectedAnf, this.selectedMonth.value)
      .subscribe({
        next: (data: FocoResponse) => {
          //console.log('Data:', data);
          const modalFocoItems = data.items
            .filter((item) => item.tipo === tipo)
            .map((item) => {
              if (item.data_Modificado) {
                item.data_Modificado = new Date(item.data_Modificado);
              }
              return {
                ...item,
                id: item.id,
                focoInt: item.focoInt,
                vendas: item.vendas || 0,
                status: item.status,
                editavel: item.editavel,
                tipo: item.tipo,
                data_Modificado: item.data_Modificado,
                produto: item.produto,
              };
            });
          //console.log('Modal Foco Items:', modalFocoItems);

          // Open the dialog here inside the subscription
          this.dialog
            .open(FocoFilterModalComponent, {
              data: { items: modalFocoItems, tipo: tipo },
              panelClass: 'tipo-filter-dialog',
              width: '70%',
            })
            .afterClosed()
            .subscribe(() => {
              this.getFoco(); // Refresh all items
            });
        },
        error: (error) => {
          console.error('Failed to fetch items', error);
          // Handle errors appropriately
        },
      });
  }

  openDetailingPdf(codProduto: string): void {
    const url = `https://prodbidscirclestorage.blob.core.windows.net/portfolio-detailing-produto/${codProduto}_Detailing.pdf`;
    this.dialog.open(PdfViewerDialogComponent, {
      width: '80%',
      height: '90%',
      panelClass: 'pdf-viewer-dialog-shell',
      data: {
        url,
        title: 'Detailing',
        theme: 'default',
      },
    });
  }

  getFoco(): void {
    /* console.log('selectedAnf:', this.selectedAnf);
    console.log('selectedMonth:', this.selectedMonth.value);
    console.log('isPastMonth:', this.isPastMonth);
    console.log('isCurrentMonth:', this.isCurrentMonth);  */
    this.focoService
      .getFoco(this.selectedAnf, this.selectedMonth.value)
      .subscribe({
        next: (data: FocoResponse) => {
          //console.log('Data:', data);
          this.dadosAtualizadosA = data.dadosAtualizadosA;
          this.focoItem = data.items.filter((item) => item.status); // filtra valores nulos ou indefinidos
          this.focoItem.forEach((item) => {
            if (item.data_Modificado) {
              item.data_Modificado = new Date(item.data_Modificado);
            }
          });
          this.focoItem = this.focoItem.map((item) => {
            // Calculate sales expectations and pace for this item
            this.calculateSalesExpectations(item.focoInt, this.dateToUse);
            const pace = this.getSalesPace(item.vendas || 0);
            //console.log(`Pace for item ${item.id}: ${pace}`);

            return {
              id: item.id,
              focoInt: item.focoInt,
              status: item.status,
              editavel: item.editavel,
              tipo: item.tipo,
              data_Modificado: item.data_Modificado,
              data_Dados_Vendas: item.data_Dados_Vendas,
              nome: item.produto.nome,
              produto: item.produto,
              cod_produto: item.produto.cod_produto,
              vendas: item.vendas || 0,
              stock: item.stock || 0,
              emfalta:
                item.focoInt - (item.vendas || 0) > 0
                  ? item.focoInt - (item.vendas || 0)
                  : 0,
              progress:
                item.focoInt > 0
                  ? ((item.vendas || 0) / item.focoInt) * 100
                  : 0,
              estado: item.status ? 'Ativo' : 'Inativo',
              atualizado: item.data_Modificado,
              expectedSalesPerDay: this.expectedSalesPerDay,
              expectedSalesToDate: this.expectedSalesToDate,
              pace: pace,
            };
          });

          // Filter items where status is 1
          const activeItems = this.focoItem.filter(
            (item) => item.status === true
          );

          //console.log(this.focoItem);
          this.paceValues = activeItems
            .map((item) => item.pace)
            .filter((pace) => pace !== undefined) as number[];
          this.vendasValues = activeItems.map((item) => item.vendas || 0);
          this.focoIntValues = activeItems.map((item) => item.focoInt);
          this.progressValues = activeItems.map((item) => item.progress || 0);
          this.productNames = activeItems.map((item) =>
            item.produto.nome.toUpperCase()
          );
          this.expectedSalesToDateValues = activeItems.map(
            (item) => item.expectedSalesToDate || 0
          );

          // Populate chartData
          this.chartData = [
            {
              data: activeItems.map((item) => item.progress || 0), // Use progress values as data
              label: 'Desempenho', // This label will be used for the legend and tooltips
              backgroundColor: activeItems.map((item) =>
                this.getProgressBarColor(item.pace || 0)
              ),
              hoverBackgroundColor: activeItems.map((item) =>
                this.getProgressBarHoverColor(item.pace || 0)
              ),
            },
            {
              data: activeItems.map((item) =>
                item.expectedSalesToDate
                  ? (item.expectedSalesToDate / item.focoInt) * 100
                  : 0
              ), // Expected sales to date as a percentage
              label: 'vendas esperadas até à data',
              backgroundColor: 'lightgrey', // Set the color to grey
            },
          ];

          // Populate chartDataAbsolute
          this.chartDataAbsolute = [
            {
              data: activeItems.map((item) => item.vendas || 0),
              label: 'vendas',
              backgroundColor: activeItems.map((item) =>
                this.getProgressBarColor(item.pace || 0)
              ),
              hoverBackgroundColor: activeItems.map((item) =>
                this.getProgressBarHoverColor(item.pace || 0)
              ),
              borderRadius: 50,
            },
            {
              data: activeItems.map((item) => item.expectedSalesToDate || 0), // Absolute Expected sales to date
              label: 'vendas esperadas até à data',
              backgroundColor: 'darkgrey',
              hoverBackgroundColor: '#E1EBF7',
              borderRadius: 50,
            },
            {
              data: activeItems.map((item) => item.focoInt),
              label: 'Objetivo',
              backgroundColor: 'lightgrey',
              hoverBackgroundColor: '#629FFE',
              borderRadius: 50,
            },
          ];

          this.dataSource = new MatTableDataSource(
            activeItems.filter((item) => item.status === true)
          );
          this.showTable = this.focoItem.length > 0; // Update this flag based on data
          this.calculateStats();
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error:', error);
          this.isLoading = false;
        },
      });
  }

  updateFoco(item: FocoItem) {
    this.focoService.updateFoco(item).subscribe({
      next: (data) => {
        //console.log(data);
        Object.assign(item, data); // para usar o objeto inteiro retornado pelo backend
        //item.data_Modificado = new Date(); // TEMP - a ideia é atualizar o Foco todo de uma vez com o Object.assign acima
        const index = this.focoItem.indexOf(item);
        const updatedItem = { ...item };
        this.focoItem = [
          ...this.focoItem.slice(0, index),
          updatedItem,
          ...this.focoItem.slice(index + 1),
        ];
        this.calculateProgressValues();
        this.changeDetector.detectChanges();
      },
      error: (error) => {
        // console.log('Erro a atualizar o Foco', error);
        this.snackBar.open('Erro a atualizar o Foco.', 'Fechar', {
          duration: 3000,
        });
      },
      complete: () => {
        this.getFoco();
        this.snackBar.open('Foco atualizado com sucesso.', 'Fechar', {
          duration: 3000,
        });
      },
    });
  }

  deleteFocoItem(item: FocoItem) {
    const dialogConfig = new MatDialogConfig<{ extraText: string }>();
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      extraText: 'Tem a certeza que quer apagar este produto do foco?',
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (item.id !== undefined) {
          this.focoService.deleteFocoItem(item.id).subscribe({
            next: () => {
              this.cdr.detach();

              this.focoItem = this.focoItem.filter((i) => i.id !== item.id);
              this.dataSource.data = [
                ...this.focoItem.filter((item) => item.status === true),
              ];
              this.calculateProgressValues();
              this.calculateStats();

              this.cdr.reattach();
              this.cdr.detectChanges();
            },
            error: (error) => {
              console.error('Erro a remover o item do foco:', error);
              this.snackBar.open('Erro a remover o item do foco.', 'Fechar', {
                duration: 3000,
              });
            },
            complete: () => {
              this.snackBar.open(
                'Item removido do foco com sucesso.',
                'Fechar',
                {
                  duration: 3000,
                }
              );
            },
          });
        }
      }
    });
  }

  getFirstValidDate(): string {
    let mostRecentDate: Date | null = null;

    for (let item of this.dataSource.data) {
      if (this.isValidDate(item.data_Dados_Vendas)) {
        const currentDate = new Date(item.data_Dados_Vendas as string | Date);
        if (!mostRecentDate || currentDate > mostRecentDate) {
          mostRecentDate = currentDate;
        }
      }
    }

    if (mostRecentDate) {
      return (
        'Última venda (produtos em Foco) registada a ' +
        this.datePipe.transform(mostRecentDate, 'dd-MM-yyyy')
      );
    }
    return 'Dados de venda não disponíveis';
  }

  isValidDate(date: Date | string | undefined): boolean {
    // Check if date is not the default '0001-01-01T00:00:00'
    if (typeof date === 'string') {
      return date !== '0001-01-01T00:00:00';
    } else if (date instanceof Date) {
      return true;
    } else {
      return false;
    }
  }

  updateChartData() {
    // Extract product names
    this.productNames = this.focoItem.map((item) => item.produto.nome);

    // Populate chartData
    this.chartData = [
      {
        data: this.focoItem.map((item) => this.getSalesPace(item.pace || 0)), // Use getSalesPace to calculate pace for each item
        label: 'Pace', // This label will be used for the legend and tooltips
        backgroundColor: this.focoItem.map((item) =>
          this.getProgressBarColor(item.pace || 0)
        ), // Use a method to get the color based on the pace value
        hoverBackgroundColor: this.focoItem.map((item) =>
          this.getProgressBarHoverColor(item.pace || 0)
        ), // Use a method to get the hover color based on the pace value
      },
    ];
  }

  getProgressBarColor(value: number): string {
    if (value === undefined) {
      return 'gray';
    } else if (value < 50) {
      return '#FF6961';
    } else if (value < 90) {
      return '#FFDC57';
    } else {
      return '#6ED66B';
    }
  }

  getProgressBarHoverColor(value: number): string {
    if (value === undefined) {
      return 'gray';
    } else if (value < 50) {
      return '#fdb0ac';
    } else if (value < 90) {
      return '#F6F1DD';
    } else {
      return '#DBF6DA';
    }
  }

  getProgressBarType(value: number): string {
    if (value === undefined) {
      return 'secondary'; // cinzento
    } else if (value < 50) {
      return 'danger'; // vermelho
    } else if (value < 90) {
      return 'warning'; // amarelo
    } else {
      return 'success'; // verde
    }
  }

  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    indexAxis: 'y',
    scales: {
      x: {
        max: 100,
        stacked: false,
      },
      y: {
        max: 100,
        grid: {
          display: false,
        },
        stacked: true,
      },
    },
    plugins: {
      legend: {
        display: true,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.dataset.label || '';
            const dataIndex = context.dataIndex;

            if (label === 'vendas esperadas até à data') {
              const expectedSalesToDate =
                this.expectedSalesToDateValues?.[dataIndex] || 0;
              const focoInt = this.focoIntValues?.[dataIndex] ?? 0;

              return [
                label,
                `vendas esperadas: ${expectedSalesToDate.toFixed(0)}`,
              ];
            } else {
              const progresso = parseFloat(
                (this.progressValues?.[dataIndex] || 0).toFixed(2)
              );
              const pace = this.paceValues?.[dataIndex] || 0;
              const focoInt = this.focoIntValues?.[dataIndex];
              const vendas = this.vendasValues?.[dataIndex] || 0;

              return [
                label,
                `Progresso atual: ${progresso}%`,
                `Progresso final previsto: ${pace}%`,
                `Objetivo: ${focoInt}`,
                `vendas: ${vendas}`,
              ];
            }
          },
        },
      },
    },
  };

  public absoluteBarChartOptions: ChartConfiguration<'bar'>['options'] = {
    indexAxis: 'y',
    scales: {
      x: {
        stacked: false,
      },
      y: {
        grid: {
          display: false,
        },
        stacked: true,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.dataset.label || '';
            const dataIndex = context.dataIndex;

            if (label === 'vendas esperadas até à data' && !this.isPastMonth) {
              const expectedSalesToDate =
                this.expectedSalesToDateValues?.[dataIndex] || 0;

              return [
                `vendas esperadas à data: ${expectedSalesToDate.toFixed(0)}`,
              ];
            } else if (label === 'Objetivo') {
              const focoInt = this.focoIntValues?.[dataIndex] || 0;
              return [`Objetivo: ${focoInt}`];
            } else {
              const vendas = this.vendasValues?.[dataIndex] || 0;

              return [`vendas: ${vendas}`];
            }
          },
        },
      },
    },
  };

  calculateProgressValues() {
    this.focoItem = this.focoItem.map((item) => {
      // Calculate the progress value for each item.
      const progress =
        item.focoInt > 0 ? ((item.vendas || 0) / item.focoInt) * 100 : 0;

      return {
        ...item,
        progress: progress,
      };
    });
  }

  calculateStats(): void {
    this.totalProgress = this.calculateTotalProgress();
    this.numProducts100Progress = this.calculateNumProducts100Progress();
  }

  calculateTotalProgress(): number {
    this.totalFocoInt = this.focoItem.reduce(
      (sum, item) => sum + item.focoInt,
      0
    );
    this.totalvendas = this.focoItem.reduce(
      (sum, item) => sum + (item.vendas || 0),
      0
    );

    return this.totalFocoInt !== 0
      ? (this.totalvendas / this.totalFocoInt) * 100
      : 0;
  }

  calculateNumProducts100Progress(): number {
    return this.focoItem.filter(
      (item) => (item.vendas || 0) / item.focoInt >= 1
    ).length;
  }

  calculateSalesExpectations(focoInt: number, date: Date): void {
    const selectedDate = new Date(date); // Create a new Date object from the selectedMonth value
    const daysInMonth = getDaysInMonth(selectedDate);
    let currentDay = new Date().getDate();

    if (this.isPastMonth) {
      currentDay = daysInMonth;
    } else if (this.isNextMonth) {
      currentDay = 0;
    }

    this.expectedSalesPerDay = focoInt / daysInMonth;
    this.expectedSalesToDate = this.expectedSalesPerDay * currentDay;
  }

  getSalesPace(vendas: number): number {
    const pace = (vendas / this.expectedSalesToDate) * 100;
    return pace > 100 ? 100 : (pace.toFixed(2) as unknown as number);
  }

  public minDate: Date | null = null; // No restriction on past dates

  chosenYearHandler(normalizedYear: Date) {
    const ctrlValue = this.selectedMonth.value || new Date();
    this.selectedMonth.setValue(setYear(ctrlValue, getYear(normalizedYear)));
    this.getFoco();
  }

  chosenMonthHandler(
    normalizedMonth: Date,
    datepicker: MatDatepicker<Date>
  ) {
    let ctrlValue = this.selectedMonth.value || new Date();
    ctrlValue = setYear(ctrlValue, getYear(normalizedMonth));
    ctrlValue = setMonth(ctrlValue, getMonth(normalizedMonth));
    this.selectedMonth.setValue(ctrlValue);
    datepicker.close();
    this.getFoco();
  }

  checkIfPastMonth(selectedMonth: Date): boolean {
    const selectedDate = new Date(selectedMonth);
    const currentDate = new Date();
    return (
      selectedDate.getFullYear() < currentDate.getFullYear() ||
      (selectedDate.getFullYear() === currentDate.getFullYear() &&
        selectedDate.getMonth() < currentDate.getMonth())
    );
  }

  get isPastMonth(): boolean {
    return this.checkIfPastMonth(this.selectedMonth.value);
  }

  checkIfCurrentMonth(selectedMonth: Date): boolean {
    const selectedDate = new Date(selectedMonth);
    const currentDate = new Date();
    return (
      selectedDate.getFullYear() === currentDate.getFullYear() &&
      selectedDate.getMonth() === currentDate.getMonth()
    );
  }

  get isCurrentMonth(): boolean {
    return this.checkIfCurrentMonth(this.selectedMonth.value);
  }

  checkIfNextMonth(selectedMonth: Date): boolean {
    const selectedDate = new Date(selectedMonth);
    const currentDate = new Date();
    return (
      selectedDate.getFullYear() === currentDate.getFullYear() &&
      selectedDate.getMonth() === currentDate.getMonth() + 1
    );
  }

  get isNextMonth(): boolean {
    return this.checkIfNextMonth(this.selectedMonth.value);
  }

  async onToggle(item: FocoItem) {
    const originalStatus = item.status;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Confirmação',
        extraText: originalStatus
          ? 'Tem a certeza que quer remover este produto do foco?'
          : 'Tem a certeza que quer voltar a adicionar este produto ao foco?',
      },
    });

    const result = await firstValueFrom(dialogRef.afterClosed());
    if (result) {
      item.status = !item.status;
      this.updateFoco(item);
    } else {
      item.status = originalStatus;
      this.changeDetector.detectChanges();
    }
  }

  openAddFocoDialog() {
    const dialogRef = this.dialog.open(FocoDialogComponent, {
      panelClass: 'tipo-filter-dialog',

      width: '50%',
      data: {
        selectedAnf: this.selectedAnf,
        selectedMonth: this.selectedMonth.value,
      },
    });

    dialogRef.afterClosed().subscribe((createdProduct: FocoItem) => {
      if (createdProduct) {
        // The user selected a product and clicked the save button
        // Add the created product to the "focoItem" array
        //console.log('Foco Criado:', createdProduct);
        this.focoItem.push(createdProduct);
        this.dataSource.data = [
          ...this.focoItem.filter((item) => item.status === true),
        ];
        this.getFoco();
      }
    });
  }

  @ViewChild('divPrint', { static: false }) divPrint!: ElementRef;
  @ViewChild('divPrintStats', { static: false }) divPrintStats!: ElementRef;

  downloadPDF(
    _divPrint: ElementRef['nativeElement'],
    orientation: 'portrait' | 'landscape' = 'portrait'
  ): void {
    if (!this.dataSource.data.length) {
      this.snackBar.open('Não existem dados para exportar.', 'Fechar', {
        duration: 3000,
      });
      return;
    }

    const monthYearText = this.datePipe.transform(this.selectedMonth.value, 'MMMM yyyy') || '';

    this.focoPdfService.generateFocoPdf({
      title: 'Foco',
      monthYear: monthYearText,
      codigoAnf: this.selectedAnf ?? '',
      data: this.dataSource.data,
      displayedColumns: this.displayedColumns,
      orientation,
    });
  }

  isGeneratingStatsPdf = false;

  async exportChartToPDF(): Promise<void> {
    const container = document.getElementById('absoluteSalesChart');
    const chartCanvas = container?.querySelector('canvas');
    if (!chartCanvas) return;

    this.isGeneratingStatsPdf = true;
    const monthYear = this.datePipe.transform(this.selectedMonth.value, 'MMMM yyyy') || '';

    try {
      await this.focoPdfService.generateStatsPdf({
        monthYear,
        codigoAnf: this.selectedAnf ?? '',
        totalProducts: this.focoItem.length,
        totalVendas: this.totalvendas ?? 0,
        totalFocoInt: this.totalFocoInt ?? 0,
        totalProgress: this.totalProgress ?? 0,
        numProducts100: this.numProducts100Progress ?? 0,
        chartCanvas,
      });
    } finally {
      this.isGeneratingStatsPdf = false;
    }
  }

  exportTableToExcel(tableId: string, name?: string): void {
    let workbook = new ExcelJS.Workbook();
    let worksheet = workbook.addWorksheet(name || 'Sheet 1');

    let table = document.getElementById(tableId) as HTMLTableElement;
    
    // Get the headers to identify columns to skip
    const headers = Array.from(table.rows[0].cells).map(cell => cell.innerText.trim().toLowerCase());
    
    // Find columns to skip by their header text
    const columnsToSkip: number[] = [];
    headers.forEach((header, index) => {
      if (header === 'info' || header === 'editar' || header === '') {
        columnsToSkip.push(index);
      }
    });

    let columnWidths: number[] = [];
    for (let i = 0; i < table.rows.length; i++) {
      let row = [];
      for (let j = 0; j < table.rows[i].cells.length; j++) {
        // Skip columns that represent info, edit, or delete
        if (!columnsToSkip.includes(j)) {
          const cellText = table.rows[i].cells[j].innerText;
          row.push(cellText);

          const cellTextLength = cellText.length;
          if (
            columnWidths[j] === undefined ||
            cellTextLength > columnWidths[j]
          ) {
            columnWidths[j] = cellTextLength;
          }
        }
      }
      worksheet.addRow(row);
    }
    
    // Adjust column widths for the exported file
    let excelColIndex = 0;
    worksheet.columns.forEach((column: Partial<ExcelJS.Column>, index: number) => {
      // Skip the columns we're not including
      if (!columnsToSkip.includes(index)) {
        column.width = columnWidths[index] + 2;
        excelColIndex++;
      }
    });

    worksheet.eachRow((row: ExcelJS.Row, rowNumber: number) => {
      row.eachCell((cell: ExcelJS.Cell, colNumber: number) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (rowNumber === 1) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '0D0D0D' },
          };
          cell.font = {
            color: { argb: 'FFFFFFFF' },
            bold: true,
          };
        }
      });
    });

    workbook.xlsx.writeBuffer().then((data: ExcelJS.Buffer) => {
      let blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `${name || 'ExportResult'}.xlsx`);
    });
  }
}
